import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-linkedin',
  templateUrl: './linkedin.component.html',
  styleUrls: ['./linkedin.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkedinIconComponent {}
